<template>
  <!-- 企业收藏 -->
  <div class="firm-body">
    <!-- 标题 企业收藏 -->
    <div class="title-Individual-center">
      企业中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">企业收藏</span>
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <!-- 切换 -->
      <div class="Toggle">
        <div class="Toggle-Select">全部收藏</div>
      </div>
      <!-- 收藏内容 -->
      <div class="collected">
        <div class="box">
          <div
            class="container"
            v-for="(item, index) in listArr1"
            :key="index"
            @click="handelSkip(item)"
          >
            <div class="logoName">
              <!-- 公司logo -->
              <div class="logo">
                <img src="../../../../assets/imgs/logo.svg" alt="" />
              </div>
              <!-- 公司名 -->
              <div class="corporation-name">{{ item.companyName }}</div>
              <!-- 收藏icon -->
              <div class="Collect-icon">
                <div class="firm-clickable" @click.stop="handelCollectFirm(item)"></div>
              </div>
            </div>
            <div class="earnings data-p">行业：{{ item.industryName }}</div>
            <div class="address data-p">地址：{{ item.companyAddress }}</div>
          </div>
        </div>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  listCompanyCollect, // 企业收藏列表
  cancelCompanyCollect, //取消公司收藏
  addCompanyCollect, //添加公司收藏
} from "../../../../assets/api/firm/firmCenter";
// 引入分页组件
import paging from "../../../../components/paging.vue";
export default {
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      },
      listArr1: [], // 企业收藏数据
    };
  },
  watch: {},
  components: { paging },
  created() {
    this.listCompanyCollect();
  },
  methods: {
    // 企业收藏列表
    listCompanyCollect() {
      var data = {
        data: {
          companyId: this.$store.getters.getCompany.id, // 公司id
        },
      };
      listCompanyCollect(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.listArr1 = res.data.list;
          this.pagingObj.totalDevice = res.data.total;
        }
      });
    },
    // 点击企业名称 跳转公司详情
    handelSkip(item) {
      // console.log(item , '111111')
      this.$router.push({
        path: "/HelpShop/Help/HelpShop",
        // query: { key: item.companyId, select: 1 },
      });
    },
    // 点击收藏 /取消收藏
    handelCollectFirm(item) {
      console.log(item, "item");
      var data = {
        data: {
          companyId: this.$store.getters.getCompany.id, // 公司id
          collectCompanyId: item.companyId,
        },
      };
      cancelCompanyCollect(data).then((res) => {
        if (res.code == 0) {
          this.$tool.PromptBox("success", "操作成功");
          this.listCompanyCollect();
        } 
      });
    },
    // 分页
    handleCurrentChange(num) {
      // num 要跳转的页面
      this.pagingObj.currentPage = num;
      // 调用数据接口
      this.listCompanyCollect();
    },
  },
};
</script>

<style scoped lang="less">
.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
// 收藏的内容
.collected {
  min-height: 410px;
  margin: 0 auto;
  margin-top: 35px;
  .box {
    min-width: 800px;
    // max-width: 840px;
    // height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .container:hover {
      box-shadow: 0px 0px 3px 0px rgba(50, 145, 248, 0.8);
    }
    .container {
      width: 390px;
      min-height: 100px;
      box-sizing: border-box;
      margin-left: 15px;
      margin-top: 15px;
      background: #ffffff;
      box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      cursor: pointer;
      // 公司logo 公司名 公司地址 收藏icon
      .logoName {
        width: 350px;
        height: 50px;
        margin: 0 auto;
        margin-top: 10px;
        display: flex;
        .logo {
          width: 50px;
          height: 50px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .corporation-name {
          max-width: 250px;
          line-height: 50px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #333300;
          font-weight: 400;
          margin-left: 10px;
        }
        .Collect-icon {
          flex: 1;
          height: 20px;
          margin: auto;
          display: flex;
          justify-content: flex-end;
          div {
            width: 20px;
            height: 20px;
            background-image: url("../../../../assets/imgs/shoucang@3x.svg");
            background-size: 100% 100%;
          }
        }
      }
    }
    // 行业地址
    .data-p {
      width: 350px;
      height: 17px;
      margin: 0 auto;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #333300;
      font-weight: 400;
      white-space: nowrap; /* 禁止文本换行，强制单行显示 */
      overflow: hidden; /* 隐藏超出容器的内容 */
      text-overflow: ellipsis;
    }
    .earnings {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .address {
      margin-bottom: 15px;
    }
  }
  .container:nth-child(2n + 1) {
    margin-left: 0px;
  }
  .container:nth-child(1) {
    margin-top: 0px;
  }
  .container:nth-child(2) {
    margin-top: 0px;
  }
}
// 切换
.Toggle {
  width: 90%;
  height: 30px;
  margin-left: 13px;
  display: flex;
  .Toggle-Select {
    height: 100%;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    text-align: center;
    font-weight: 400;
    box-sizing: border-box;
    cursor: pointer;
    color: #409eff ;
    border-bottom: 2px solid #409eff ;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    // margin-right: 45px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
